import module from 'module';
import './system-health-check.component.less';
import templateUrl from './system-health-check.template.html';

import { healthCheckPhase } from 'constants/healthCheckPhase';

class SystemHealthCheck {
  constructor(http, authentication, popup) {
    this.checks = null;
    this.hideOk = true;
    this.healthCheckPhase = healthCheckPhase.HEALTH_CHECK;

    this.http = http;
    this.authentication = authentication;
    this.popup = popup;
  }

  refetchHealthChecks() {
    this.http.get(`/system/health-details?includeStatement=true&phases=${this.healthCheckPhase}&branchId=${this.authentication.context.branchId}`)
      .success(data => this.checks = data)
      .error((err) => {
        this.popup({
          header: 'Error',
          text: err.errorMessage
        })
      });
  }

  $onInit() {
    this.refetchHealthChecks();
  }
}

module.component('systemHealthCheck', {
  templateUrl,
  controller: SystemHealthCheck
});